import { AfterViewInit, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { find, forEach, isNil } from 'lodash';

import { Recommendation } from '@app/shared/constants';

@Component({
  selector: 'app-street-light-planner-step3',
  templateUrl: './street-light-planner-step3.component.html',
  styleUrls: ['./street-light-planner-step3.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StreetLightPlannerStep3Component implements AfterViewInit {
  @Input() type: any = null;
  @Output() typeSelectChange = new EventEmitter(true);

  public choices: StreetLightRecommendation[] = [
    {
      id: find(Recommendation, (value) => value.type.toLowerCase() === 'Economical'.toLowerCase())?.id,
      name: 'Economical',
      type: 'Wirtschaftlichkeit',
      tooltip: {
        html: `
        <p>
          <em class="em">Bestimmender Faktor:</em>
          <strong>Amortisationszeit</strong></br>Wir empfehlen Ihnen die LED-Leuchten,
          mit denen Sie Ihre Investitionskosten möglichst schnell wieder durch die eingesparten Stromkosten refinanziert haben
        </p>`,
        isVisible: false,
      },
    },
    {
      id: find(Recommendation, (value) => value.type.toLowerCase() === 'Sustainable'.toLowerCase())?.id,
      name: 'Sustainable',
      type: 'Nachhaltigkeit',
      tooltip: {
        html: `
        <p>
          <em class="em">Bestimmender Faktor: Energieeinsparung</em>
          </br>
          Wir empfehlen Ihnen zuerst umweltschädliche Quecksilberdampfleuchten
          auszutauschen und anschließend die Leuchten, mit der höchsten Energieeinsparung
        </p>`,
        isVisible: false,
      },
    },
    {
      id: find(Recommendation, (value) => value.type.toLowerCase() === 'Renovation'.toLowerCase())?.id,
      name: 'Substance-renewal',
      type: 'Substanzerneuerung',
      tooltip: {
        html: `
        <p>
          <em class="em">Bestimmender Faktor:</em>
          </br>
          <em class="em">Alter und Art der Leuchte</em>
          </br>
          Wir empfehlen die Leuchten nach folgender Reihenfolge austauschen:
          </br>
          1. Umweltschädliche Quecksilberdampfleuchten
          </br>
          2. Leuchten von Herstellern, die sich aus dem Straßenbeleuchtungsmarkt zurückgezogen haben
          </br>
          3. Älteste Leuchte
        </p>`,
        isVisible: false,
      },
    },
  ];
  public active = this.choices[0].id;

  ngAfterViewInit() {
    if (isNil(this.type)) {
      const initial = this.choices[0];
      this.typeSelectChange.emit({ id: initial.id, name: initial.name });
    } else {
      setTimeout(() => {
        this.active = this.type;
      });
    }
  }

  onCheckChange(type: StreetLightRecommendation) {
    this.active = type.id;
    this.typeSelectChange.emit({ id: type.id, name: type.name });
  }

  onTooltipClick(value: StreetLightRecommendation) {
    if (!value.tooltip.isVisible) {
      forEach(this.choices, (choice) => {
        choice.tooltip.isVisible = false;
      });
      value.tooltip.isVisible = true;
    } else {
      value.tooltip.isVisible = !value.tooltip.isVisible;
    }
  }

  trackByFn(_: number, item: StreetLightRecommendation) {
    return item.id;
  }
}

export interface StreetLightRecommendation {
  id?: string;
  name: string;
  type: string;
  tooltip: Tooltip;
}

export interface Tooltip {
  html: string;
  isVisible: boolean;
}
